import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getExchangeUrl } from '@/utils/location';
import { HeaderItem } from '.';

export const useProfileList = () => {
  const { t } = useTranslation();

  return useMemo<HeaderItem[]>(
    () => [
      { title: t('account.profile.security1'), url: '/account/profile/security' },
      { title: t('account.profile.verified'), url: '/account/profile/verified' },
      { title: t('account.profile.invite'), url: '/account/profile/api' },
      // { title: t('account.profile.Vouchers'), url: getExchangeUrl().myVouchers },
      { title: t('account.profile.api'), url: '/account/profile/invite' },
    ],
    [t],
  );
};
